let omsBlotterRows = [];
export const getOmsBlotterRows = () => omsBlotterRows;
export const setOmsBlotterRows = (rows) => (omsBlotterRows = rows);
